import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { ShadowSlight } from 'library/constants/styles-config';
import { Header5 } from 'library/styles/text';

// eslint-disable-next-line import/prefer-default-export
export const StyledLoader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  div {
    top: calc(50% - 30px);
    left: calc(50% - 30px);
    width: 60px;

    i {
      color: #fff;
      font-size: 60px;
    }
  }
`;

export const Preview = styled.label`
  margin: 40px 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-direction: column;
  z-index: 4;
  opacity: ${({ isFileOver }) => (isFileOver ? 0.4 : 1)};
  padding: ${({ isEmpty }) => (isEmpty ? '70px 96px' : 0)};
  cursor: ${({ isLoading }) => (isLoading ? 'not-allowed' : 'pointer')};
  background-color: ${({ isEmpty }) => (isEmpty ? '#F8F9FA' : 'transparent')};
  border: ${({ isEmpty }) => (isEmpty ? '1px dashed #A3AFB3' : 'none')};
  border-radius: ${({ isEmpty }) => (isEmpty ? '24px' : 0)};
  box-shadow: ${({ isEmpty }) => (isEmpty ? ShadowSlight : 'none')};
  pointer-events: ${({ isLoading }) => (isLoading ? 'none' : 'inherit')};

  input {
    visibility: hidden;
    position: absolute;
    width: 100%;
    height: 100%;
  }
  
  img {
    border-radius: ${({ isEmpty }) => (!isEmpty ? '24px' : 0)};
    box-shadow: ${({ isEmpty }) => (!isEmpty ? ShadowSlight : 'none')};
    width: 100%;
    opacity: ${({ isLoading }) => (isLoading ? 0.4 : 1)};
  }
  
  i {
    //font-size: 90px;
    color: ${Colors.violet};
  }
  
  ${Header5} {
    color: ${Colors.violet};
    font-weight: 700;
  }
`;
